import { render, staticRenderFns } from "./NotasComponent.vue?vue&type=template&id=7b50914a"
import script from "./NotasComponent.vue?vue&type=script&lang=js"
export * from "./NotasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports